import { transformInsuranceCards } from "./InsuranceCardsTransformer";
import {
  transformFilterPlans,
  transformHeaderTitle,
  transformItineraryInfo,
  transformPersuasion,
} from "./PassthroughTransformer";

/**
 * Component transformer mapping - maps component IDs to transformer functions
 */
export const COMPONENT_TRANSFORMER: Record<
  string,
  (apiData: unknown) => unknown
> = {
  HEADER_TITLE: transformHeaderTitle,
  FILTER_PLANS: transformFilterPlans,
  INSURANCE_CARDS: transformInsuranceCards,
  ITINERARY_INFO: transformItineraryInfo,
  PERSUASION: transformPersuasion,
};

export * from "./types";

export default {
  COMPONENT_TRANSFORMER,
};
